import { getTenantIdFromStorage } from '../authentication/supertokens';

export interface Member {
    user_id: string;
    name?: string;
    email?: string;
    role?: string;
    [key: string]: any;
}

export interface Organization {
    access_code: string;
}

export const fetchOrganizationMembers = async (): Promise<{ members: Member[], access_code: string }> => {
    const tenantId = getTenantIdFromStorage();
    if (!tenantId) {
        throw new Error('No tenant ID found');
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${tenantId}/members`, {
        credentials: 'include',
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch members');
    }

    const data = await response.json();
    // Sort members alphabetically by name
    const sortedMembers = data.members.sort((a: Member, b: Member) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
    });

    return {
        members: sortedMembers,
        access_code: data.access_code
    };
};

export const refreshAccessCode = async (): Promise<Organization> => {
    const tenantId = getTenantIdFromStorage();
    if (!tenantId) {
        throw new Error('No tenant ID found');
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${tenantId}/refresh-access-code`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (response.status === 403) {
        throw new Error('You do not have permission to refresh the access code. Only organization admins can perform this action.');
    }

    if (!response.ok) {
        throw new Error('Failed to refresh access code');
    }

    return response.json();
}; 